"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uxUtils = require("@site/ux-utils");
const TestimonialCardWithImage = ({
  eyebrowTitle,
  text,
  authorName,
  authorTitle,
  imageSrc
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "testimonial-with-image",
    "data-testid": "testimonial-with-image",
    className: "testimonial-with-image"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "eyebrow"
  }, (0, _uxUtils.useFormatMessage)(eyebrowTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: "testimonial-text"
  }, "\"", (0, _uxUtils.useFormatMessage)(text), "\""), /*#__PURE__*/_react.default.createElement("div", {
    className: "author"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "author-name"
  }, (0, _uxUtils.useFormatMessage)(authorName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "author-title"
  }, (0, _uxUtils.useFormatMessage)(authorTitle)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: imageSrc,
    alt: `${authorName}'s testimonial`
  })));
};
TestimonialCardWithImage.propTypes = {
  eyebrowTitle: _propTypes.default.string,
  text: _propTypes.default.string,
  authorName: _propTypes.default.string,
  authorTitle: _propTypes.default.string,
  imageSrc: _propTypes.default.string
};
var _default = exports.default = TestimonialCardWithImage;